import React, { FC } from 'react';

import block from '../../utils/bem-cn-lite';
import type { ILoader } from './ILoader';

import './Loader.css';

const cn = block('loader');

const Loader: FC<ILoader> = ({ type = 'primary', size, ...props }) => {
    return (
        <div {...props} className={cn({ type, size })}>
            {[0, 1, 2].map((item) => (
                <div className={cn('dot', { type, size })} key={`loader-dot${item}`} />
            ))}
        </div>
    );
};

export default Loader;
